export enum DisplayMode {
  fullpage,
  modal,
}
